<template>
  <div class="support-and-footer">
    <div id="graypage">
      <div class="page_content" style="padding-top: 80px;">

  <div class="support">
  <h2 style="margin-bottom: 30px;">
    In-House Manufactured Beauty Equipment (Made in Japan) – Sales & Service
  </h2>

  <p>
    All equipment from Scandinavia Service Co., Ltd. is developed in-house and carefully manufactured and assembled in Japan.<br>
    As our equipment is 100% made in Japan with a focus on quality and safety, it is highly reliable and designed for long-term use.<br>
    In-house parts management and repair services also ensure that replacement parts remain readily available even years after purchase.<br>
    In the unlikely event of a malfunction, our service team is available on weekends and public holidays (9:00–18:00) and provides support within 48 hours,<br>
    helping to minimize the burden on our customers.
  </p>
</div>

        <div class="support_pie">
          <div id="pie2"></div>
          <div id="pie3"></div>
          <div id="pie4"></div>
          <div id="pie5"></div>
        </div>

        <div class="support_pie_smallscreen">
          <img src="/assets/img/support_2_5detail_eng.png" alt="販売から修理・メンテナンスまで一貫したサービス提供">
        </div>

        <div class="support">
          <img src="/assets/img/support_06_eng.png" alt="特許と適合審査合格">
        </div>
        <div class="support">
          <img src="/assets/img/support_07_1_eng.png" alt="導入サロン様へのサポート">
        </div>
        <div class="support_block">
          <div id="supportblock1"></div>
          <div id="supportblock2"></div>
          <div id="supportblock3"></div>
          <div id="supportblock4"></div>
        </div>

        <div class="supportblock_smallscreen">
          <img src="/assets/img/support_07_2detail_eng.png" alt="ドクターサポート・技術指導・メニュー及び広告ツールの作成・サロン様の安定した経営と売上に貢献">
        </div>

        <div class="support">
          <img src="/assets/img/support_08_eng.png" alt="ニーズに合わせた化粧品の開発・販売">
        </div>

        <shop-movie-partner-eng></shop-movie-partner-eng>

      </div>
    </div>
    <footer2eng></footer2eng>
  </div>
</template>

<script>

 export default {
   name: 'supporteng',
   components: {
     scmenueng: () => import('../components/scMenuEng.vue'),
     'shop-movie-partner-eng': () => import('../components/ShopMoviePartnerEng.vue'),
     footer2eng: () => import('../components/Footer2Eng.vue')
   },
 }
</script>

<style lang="scss">
 #scmenueng {
   /*    padding-top: -200px; */
   /*    margin-top: -10px; */
   /*    z-index: 100; */
 }

 /*
 #scmenu {
   display: none;
 }
 */

 #scmenueng .menu-section {
   position: absolute;
   /*    margin-top: 42px; */
   margin-left: -30px;
   z-index: 11;
 }

 .support-and-footer-eng {
   margin-top: 80px;
 }

 @media (min-width: 601px) {
   .support-and-footer {
     /* to deal with floating menu*/
     /* margin-top: 80px; */
   }
 }
 .support {
   img {
     display: block;
     margin-top: 20px;
   }
 }

 @mixin pie-style() {
   width: 480px;
   height: 385px;
   opacity: 0.8;
   transition: opacity .55s ease-in-out;
 }
 @mixin pie-hover-style() {
   opacity: 1.0;
   transition: opacity .55s ease-in-out;
 }
 .support_pie {
   margin: 0;
   padding: 0;
   display: flex;
   flex-wrap: wrap;
   & #pie2 {
     @include pie-style();
     background-image: url("/assets/img/support_02_eng.png");
   }
   & #pie2:hover {
     @include pie-hover-style();
     background-image: url("/assets/img/support_02detail_eng.png");
   }
   & #pie3 {
     @include pie-style();
     background-image: url("/assets/img/support_03_eng.png");
   }
   & #pie3:hover {
     @include pie-hover-style();
     background-image: url("/assets/img/support_03detail_eng.png");
   }
   & #pie4 {
     @include pie-style();
     background-image: url("/assets/img/support_04_eng.png");
   }
   & #pie4:hover {
     @include pie-hover-style();
     background-image: url("/assets/img/support_04detail_eng.png");
   }
   & #pie5 {
     @include pie-style();
     background-image: url("/assets/img/support_05_eng.png");
   }
   & #pie5:hover {
     @include pie-hover-style();
     background-image: url("/assets/img/support_05detail_eng.png");
   }
 }
 .support_pie_smallscreen {
   display: none;
 }

 .support_block {
   margin: 0;
   padding: 0;
   display: flex;
   flex-wrap: wrap;
   & #supportblock1 {
     width: 247px;
     height: 398px;
     opacity: 0.8;
     transition: opacity .55s ease-in-out;
     background-image: url("/assets/img/support_07_2_1_eng.png");
   }
   & #supportblock1:hover {
     opacity: 1.0;
     transition: opacity .55s ease-in-out;
     background-image: url("/assets/img/support_07_2_1detail_eng.png");
   }
   & #supportblock2 {
     width: 213px;
     height: 398px;
     opacity: 0.8;
     transition: opacity .55s ease-in-out;
     background-image: url("/assets/img/support_07_2_2_eng.png");
   }
   & #supportblock2:hover {
     opacity: 1.0;
     transition: opacity .55s ease-in-out;
     background-image: url("/assets/img/support_07_2_2detail_eng.png");
   }
   & #supportblock3 {
     width: 212px;
     height: 398px;
     opacity: 0.8;
     transition: opacity .55s ease-in-out;
     background-image: url("/assets/img/support_07_2_3_eng.png");
   }
   & #supportblock3:hover {
     opacity: 1.0;
     transition: opacity .55s ease-in-out;
     background-image: url("/assets/img/support_07_2_3detail_eng.png");
   }
   & #supportblock4 {
     width: 288px;
     height: 398px;
     // opacity: 0.8;
     // transition: opacity .55s ease-in-out;
     background-image: url("/assets/img/support_07_2_4_eng.png");
   }
 }

 .supportblock_smallscreen {
   display: none;
 }
 @media (max-width: 600px) {
   .support {
     img{
       width: 100%;
     }
   }
   .support_pie {
     display: none;
   }
   .support_block {
     display: none;
   }
   .support_pie_smallscreen {
     display: block;
     img {
       display: block;
       width: 100%;
     }
   }
   .supportblock_smallscreen {
     display: block;
     img {
       display: block;
       width: 100%;
     }
   }
 }
</style>
